import { MembershipsCreatorV2ApiClient } from '@fourthwall/services/dist/MembershipsCreatorV2ApiClient'
import { createMutationHook } from '@fourthwall/utils'

export const useFinishLiveStreamPostMutation = createMutationHook(
  MembershipsCreatorV2ApiClient.finishLiveStreamPost,
  {
    mutationKey: ['finishLiveStreamPost'],
  },
)
